<template lang="pug">
.v-field-tab-switch.field-tab-switch
	.field-tab-switch__label(v-if="field.label" :class="{'field-tab-switch__label--has-note': field.note}")
		label.field-tab-switch__label-text(:for="uniqueId") {{field.label}}
		.field-tab-switch__tooltip(v-if="field.note")
			.field-tab-switch__tooltip-icon ?
			.field-tab-switch__tooltip-dd-wrap
				.field-tab-switch__tooltip-dd
					.field-tab-switch__tooltip-dd-text.scrollbar {{field.note}}
	.field-tab-switch__tabs
		template(v-for="(option, index) in field.options" :key="index")
			button.field-tab-switch__btn(@click="handleInput(option);"
					:class="{'field-tab-switch__btn--active' : localValue === option.value}"
					:disabled="localValue === option.value")
				| {{option.text}}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	emits: [
		'update:model-value',
	],

	props: {
		field: {
			type: Object,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	data() {
		return {
			localValue: null,
			uniqueId: uniqueId('field-')
		}
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput(option) {
			this.localValue = option.value;
			this.$emit('update:model-value', this.localValue);
			this.updateLocalValue()
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		}
	}
}
</script>